module.exports = __webpack_public_path__ + "static/media/wbi-logo-v2-primary.5e0584ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/wbi-logo-v2-primary.svg
// module id = 6855
// module chunks = 0